import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { App } from './app/App';

// Prevent search engines from indexing non-production environments (e.g. staging)
if (process.env.REACT_APP_NODE_ENV !== 'production') {
  const robotsMeta = document.createElement('meta');
  robotsMeta.name = 'robots';
  robotsMeta.content = 'noindex, nofollow';
  document.head.appendChild(robotsMeta);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
